(function ($) {

Drupal.behaviors.product_brief_aerin = {
   _getProductData: function(pId) {
     var data = false;
     var products, qsData;

     if (_.isEmpty(pId)) {
       return data;
     }

     if (page_data['catalog-mpp'] !== undefined) {
       if (!!page_data['catalog-mpp'].categories && !! page_data['catalog-mpp'].categories[0].products) {
         qsData = page_data['catalog-mpp'].categories[0].products;
       }
     }
     else if (page_data['custom-mpp'] !== undefined) {
       if (!!page_data['custom-mpp'].products) {
         qsData = page_data['custom-mpp'].products;
       }
     }

     if (!!qsData) {
       data = _.find(qsData, function(p) {
         return p.PRODUCT_ID == pId;
       });
     }

     return data;
  },

  attach: function (context, settings) {
    var self = this;
    var $template = $('.js-product-brief', context);

    $('.button__quickshop', $template).once().click(function(e) {
      e.preventDefault();

      var $self = $(this);
      var quickshopPID = $self.attr('data-productid');
      var quickshopData = self._getProductData(quickshopPID);

      // Note: this may seems like a hack; however, it somehow prevents the page
      // from scrolling back to the top whenever a quickshop is launched. Something
      // in colorbox makes it jump, and this appears to fix it.
      $self.removeAttr('href');

      if (!!quickshopData) {
        site.quickshop(quickshopData);
      }
      else {
        console.log('Missing product data for product id ' + quickshopPID);
      }

      return false;
    });
  }
};

})(jQuery);
